import useRequest from '@/websdk/utils/request';
export default (function () {
  const { isRequestSuccessed, exec } = useRequest({
    url: '/api/inspection_product_configs/main',
    name: 'productInspectionSettingPOST',
    method: 'POST',
  });
  return [isRequestSuccessed, exec];
});
